
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '编码名称',
value: this.$route.params.UN_NAME
}, {
label: '编码说明',
value: this.$route.params.UN_REMARK
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_UNCodeDetail.vue